<template>
  <div style="min-height: 100vh; position: relative">
    <div
      v-if="!selectedBot.status"
      style="position: absolute; z-index: 2; background-color: #ecececbd;top: 0; left: 0; right: 0; bottom: 0 "
    >
      <div class="text-xs-center mt-5 pt-5" style="margin-bottom: 25px;">
        <v-card max-width="600" style="margin: auto">
          <v-card-text>
            <h2 style="text-shadow: 1px 1px 20px #9e9e9e;" class="display-1">
              {{ $t('If you want to test, please activate your bot') }}
            </h2>
            <p>
              {{ $t('Information will not be recorded in analytics if the bot is inactivated') }}
            </p>

            <v-btn
              depressed
              style="margin-bottom:1.5em"
              @click="toggleBotStatus"
              small
              color="primary"
              >{{ $t('Click for starting your Bot') }}</v-btn
            >
          </v-card-text>
        </v-card>
      </div>
    </div>

    <v-container fluid>
      <v-layout wrap>
        <v-flex xs12 sm8>
          <v-btn
            depressed
            :outline="filter != 'all'"
            :color="filter == 'all' ? 'primary' : 'grey'"
            @click="filter = 'all'"
            class="ma-0 mr-1 mb-1"
            >{{ $t('All') }}</v-btn
          >
          <v-btn
            depressed
            :outline="filter != 'facebook'"
            :color="filter == 'facebook' ? 'primary' : 'grey'"
            @click="filter = 'facebook'"
            class="ma-0 mr-1 mb-1"
          >
            <i class="fab fa-facebook-square mr-1"></i>
            {{ $t('Facebook') }}
          </v-btn>
          <v-btn
            depressed
            :outline="filter != 'line'"
            :color="filter == 'line' ? 'primary' : 'grey'"
            @click="filter = 'line'"
            class="ma-0 mr-1 mb-1"
          >
            <i class="fab fa-line mr-1"></i>
            {{ $t('Line') }}
          </v-btn>
          <v-btn
              depressed
              :outline="filter != 'instagram'"
              :color="filter== 'instagram' ? 'primary' : 'grey'"
              @click="
                filter = 'instagram'
                getIntent()
              "
              class="ma-0 mr-1 mb-1"
            >
              <i class="fab fa-instagram mr-1"></i>
              {{ $t('Instagram') }}</v-btn
            >
            <v-btn
              depressed
              :outline="filter!= 'google'"
              :color="filter == 'google' ? 'primary' : 'grey'"
              @click="
                filter = 'google'
              "
              class="ma-0 mr-1 mb-1"
            >
              <i class="fab fa-google mr-1"></i>
              {{ $t('Google') }}</v-btn
            >
        </v-flex>
        <v-flex xs12 sm4 class="text-sm-right">
          <template v-if="loading">
            <v-btn :loading="true" color="grey" outline class="ma-0 mb-1"></v-btn>
          </template>
          <template v-else>
            <v-btn
              v-if="$store.getters.getPackage != 'premium'"
              outline
              color="grey"
              class="ma-0 mb-1"
            >
              <i class="fas fa-file-export mr-1"></i>
              {{ $t('export') }}
              <v-premium-lock></v-premium-lock>
            </v-btn>
            <v-btn
              v-else-if="$store.getters.getPackage == 'premium'"
              @click="exportDashboard"
              color="grey"
              outline
              class="ma-0 mb-1"
            >
              <i class="fas fa-file-export mr-1"></i>
              {{ $t('export') }}
            </v-btn>
          </template>
        </v-flex>
      </v-layout>

      <date-filter v-model="selectedDate"></date-filter>

      <h2 class="title">{{ $t('Metrics') }}</h2>
      <active-user-by-date
        :loading="loadingActiveUserByDate"
        :selectedDate="selectedDate"
        :filter="filter"
        @onLoaded="onLoadingActiveUserByDate"
      ></active-user-by-date>
      <active-user-by-time
        :loading="loadingActiveUserByTime"
        :selectedDate="selectedDate"
        :filter="filter"
        @onLoaded="onLoadingActiveUserByTime"
      ></active-user-by-time>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ActiveUserByDate from './ActiveUserByDate.vue'
import ActiveUserByTime from './ActiveUserByTime.vue'
import DateFilter from './DateFilter'

import dayjs from 'dayjs'
import numeral from 'numeral'
import XLSX from 'xlsx'

export default {
  components: {
    ActiveUserByDate,
    ActiveUserByTime,
    DateFilter
  },
  computed: {
    loading: function() {
      return this.loadingActiveUserByDate && this.loadingActiveUserByTime
    },
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  data: function() {
    return {
      loadingActiveUserByDate: true,
      loadingActiveUserByTime: true,
      filter: 'all',
      selectedDate: {
        start: dayjs()
          .subtract(7, 'days')
          .format('YYYY-MM-DD'),
        end: dayjs().format('YYYY-MM-DD')
      },
      activeuserbydateSeries: [],
      activeuserbytimeSeries: []
    }
  },
  methods: {
    onLoadingActiveUserByDate: function(value) {
      this.loadingActiveUserByDate = value.loading
      if (value.data) {
        this.activeuserbydateSeries = value.data
      }
    },
    onLoadingActiveUserByTime: function(value) {
      this.loadingActiveUserByTime = value.loading
      if (value.data) {
        this.activeuserbytimeSeries = value.data
      }
    },
    exportDashboard: function() {
      let vm = this
      let csvContent = ''
      if (vm.loading) {
        return false
      }
      let json = []
      json.push([
        `${this.$t('from')} ` +
          dayjs(vm.selectedDate.start).format('DD/MM/YYYY') +
          ` ${this.$t('to')} ` +
          dayjs(vm.selectedDate.end).format('DD/MM/YYYY')
      ])

      json.push([])
      json.push([this.$t('Active Users by Date')])
      json.push([
        this.$t('Date'),
        vm.activeuserbydateSeries[0].name,
        vm.activeuserbydateSeries[1].name,
        vm.activeuserbydateSeries[2].name
      ])

      $.each(vm.activeuserbydateSeries[0].data, function(index, seriesData) {
        json.push([
          dayjs(seriesData[0]).format('DD/MM/YYYY'),
          numeral(vm.activeuserbydateSeries[0].data[index][1]).format('0,0'),
          numeral(vm.activeuserbydateSeries[1].data[index][1]).format('0,0'),
          numeral(vm.activeuserbydateSeries[2].data[index][1]).format('0,0')
        ])
      })

      const dataWS = XLSX.utils.aoa_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'zwizdata-matrics.xlsx')

      // csvContent +=
      //   'From,"' +
      //   dayjs(vm.selectedDate.start).format('DD/MM/YYYY') +
      //   '",To,"' +
      //   dayjs(vm.selectedDate.end).format('DD/MM/YYYY') +
      //   '"\r\n'

      // csvContent += 'Active Users by Date\r\n'
      // csvContent +=
      //   'Date,' +
      //   vm.activeuserbydateSeries[0].name +
      //   ',' +
      //   vm.activeuserbydateSeries[1].name +
      //   '\r\n'

      // $.each(vm.activeuserbydateSeries[0].data, function(index, seriesData) {
      //   csvContent +=
      //     dayjs(seriesData[0]).format('DD/MM/YYYY') +
      //     ',"' +
      //     numeral(vm.activeuserbydateSeries[0].data[index][1]).format('0,0') +
      //     '","' +
      //     numeral(vm.activeuserbydateSeries[1].data[index][1]).format('0,0') +
      //     '"\r\n'
      // })
      // csvContent += '\r\n'
      // csvContent += 'Messages by Time\r\n'
      // csvContent += 'Time,Messages\r\n'

      // $.each(vm.activeuserbytimeSeries[0].data, function(index, seriesData) {
      //   csvContent += index + ':00' + ',"' + numeral(seriesData).format('0,0') + '"\r\n'
      // })

      // vm.exportCsv(csvContent, 'crm')
    },
    toggleBotStatus: async function() {
      let bot = Object.assign({}, this.selectedBot)
      bot.status = !bot.status
      this.$store.dispatch('loading')
      await this.$store.dispatch('toggleBotStatus', bot)
      this.$store.dispatch('loading')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytics/ActiveUserGraph.vue